import React from 'react';
import { useQuery } from '@apollo/client';
import { useClient } from '../ClientContext';
import { NullState } from '../../bench-internal-theme';
import { WrappedSpinner } from '../../spinner';
import { GET_CONNECTIONS } from './queries';
import { groupBy } from 'lodash';
import Connections from './Connections';
import styled from 'styled-components';
import { Text } from 'bench-internal-theme';
import { MicroFrontend } from 'micro-frontend';
import { SplitFeatureFlags } from 'bk-web-app/features';
import { FeatureValue, useFeatureFlags } from '@bench/ff-client';

const ConnectionSectionsLayout = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
`;
const ConnectionsContainer = () => {
  const client = useClient();
  const [featureState] = useFeatureFlags();
  const {
    featureContext: { features },
  } = featureState;

  // We are using the Finch Sync feature flag to determine if the BPA connection be enabled
  const isBpaCardEnabled =
    features[SplitFeatureFlags.FINCH_SYNC_ENABLED]?.value === FeatureValue.FEATURE_ON;

  const { loading, error, data } = useQuery(GET_CONNECTIONS, {
    variables: { clientId: client?.id },
  });

  if (error) {
    return (
      <NullState
        bigEmoji="🙈"
        title="Uh oh! An error was encountered while fetching the data for this page."
      />
    );
  }

  if (loading) {
    return <WrappedSpinner />;
  }

  const connections = data?.client?.financialConnections || [];
  const businessInitialSyncDate = client?.more?.integrationSettings?.initialSyncDate;

  return (
    <ConnectionSectionsLayout>
      <Connections connectionsBySource={groupBy(connections, 'source')} />
      <Text styleType="largeBold">Finch</Text>
      <MicroFrontend
        name={
          isBpaCardEnabled
            ? 'FinancialIntegrationsBpaManageFinchConnections'
            : 'FinancialIntegrationsCustomerManageFinchConnections'
        }
        data={{
          businessId: client?.id,
          businessName: client.company,
          isInternalView: true,
          businessInitialSyncDate,
        }}
      />
    </ConnectionSectionsLayout>
  );
};

export default ConnectionsContainer;
